export const COUNTDOWN_TIMER_SEC = 32;
export const COUNTDOWN_TIMER_INTERVAL_MS = 1000;
export const COUNTDOWN_TIMER_INTERVAL_SEC = 1;
export const IDLE_TIMEOUT_THRESHOLD = 3000;
